/* tslint:disable:object-literal-shorthand */
import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExgDataListComponent, ExgDataTableComponent, ExgModalService, ExgTableSettingsComponent} from 'exc-controls-v2';
import {ExgTabV2Component, ExgTabV2ComponentHeaderElement} from '../../misc/exg-tab-v2/exg-tab-v2.component';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';
import {ExcRestService, IExcDataDistinct, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ExgApplicationTab, ExgApplicationTabService, IExgTab} from 'exc-tab-v2';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {NestedTreeControl} from '@angular/cdk/tree';
import {ApplicationService} from '../../services/application.service';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {IExgEvent} from '../../misc/interfaces/IExgEvent';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {DataService} from '../../services/data.service';
import {ITaskSummaryData} from '../../misc/interfaces/ITaskSummaryData';
import {ExgFilterChipsComponent} from '../../misc/exg-filter-chips/exg-filter-chips.component';
import {ExcSecurityService} from 'exc-security-v2';
import {BehaviorSubject} from 'rxjs';
import {CalculationVersionComponent} from '../../Calculation/calculation-version/calculation-version.component';
import {AppComponent} from '../../app.component';
import {CaseDataService} from '../../services/case-data.service';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskListComponent
  extends ExcTranslation
  implements OnInit, AfterViewInit, IExgEvent, IExgTab {
  /****************************/
  @ViewChild('VCtaskTable', {read: ExgDataTableComponent})
  VCtaskTable!: ExgDataTableComponent;
  @ViewChild('VCFormularList', {read: ExgDataListComponent})
  VCFormularList!: ExgDataListComponent;
  @ViewChild('VCrightTabControl', {read: ExgTabV2Component})
  VCrightTabControl!: ExgTabV2Component;
  @ViewChild('VCreceiptList', {read: ExgDataListComponent})
  VCreceiptList!: ExgDataListComponent;
  @ViewChild('VCtaskTableFilterControl', {read: ExgFilterComponent})
  VCtaskTableFilterControl!: ExgFilterComponent;
  @ViewChild('VCtaskTableSortControl', {read: ExgFilterComponent})
  VCtaskTableSortControl!: ExgFilterComponent;
  @ViewChild('VCtaskTableSearchControl', {read: ExgFilterComponent})
  VCtaskTableSearchControl!: ExgFilterComponent;
  @ViewChild(ExgFilterChipsComponent) VCFilterChips!: ExgFilterChipsComponent;
  @ViewChild(ExgTableSettingsComponent) VCtableDefinitionSettings!: ExgTableSettingsComponent;
  @ViewChild('VCVorganglist', {read: ExgDataListComponent}) VCVorganglist!: ExgDataListComponent;
  @ViewChild('PhotoDocList', {read: ExgDataListComponent}) PhotoDocList!: ExgDataListComponent;
  /****************************/

  tabinstance: any;
  Data: any;
  Events = new ExgApplicationEventEmitter();

  rightDrawerVisible = false;
  rightTabs: ExgTabV2ComponentHeaderElement[] = [];
  init = true;
  preFilterDefinition: any[] = [];
  selectedMod: any;
  selectedType: any;
  openAttachmentFolder: any;
  openReportFolder: string[] = [];

  taskTable = {
    selectKey: 'vorgID',
    newV2Table: false,
    prefilter: 0,
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    uiFilterEnumGroup: [
      {
        enmName: 'Schadenart',
        enmField: 'aue_enmIdent_SchadenArt',
        enmTable: 'AuftragE_EIS',
        enmAlt: false,
        enmAltTT: true
      },
      {
        enmName: 'VorgangStatus',
        enmField: 'vorg_enmIdent_VorgangStatus',
        enmTable: 'Vorgang',
      },
      {
        enmName: 'VorgangTyp',
        enmField: 'vorg_enmIdent_VorgangTyp',
        enmTable: 'Vorgang',
      },
      {
        enmName: 'Versicherungsart',
        enmField: 'aue_enmIdent_Versicherungsart',
        enmTable: 'AuftragE_EIS',
      },
      // {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
    ],
    uiFilterSearchFields: [
      {table: 'Vorgang', tableField: 'vorgNr'},
      {table: 'Vorgang', tableField: 'vorgBearbeiter', tableFieldCaptionAlt: this.getRessource('TableRenames.Bearbeiter')},
      // {table: 'Vorgang', tableField: 'Bearbeiter_Handy'},
      {table: 'Vorgang', tableField: 'vorgFrist'},
      {table: 'All', tableField: 'vorgLCU', groupCaption: 'Vorgang'},
      {table: 'All', tableField: 'vorgLCD', groupCaption: 'Vorgang'},
      {table: 'All', tableField: 'vorgCKD', groupCaption: 'Vorgang'},
      {table: 'AuftragE_EIS', tableField: 'aueSchadenNr', groupCaption: 'Schaden'},
      {table: 'AuftragE_EIS', tableField: 'aueVersicherungsnehmer', groupCaption: 'Schaden'},
      {table: 'AuftragE_EIS', tableField: 'aueSchadenOrt', groupCaption: 'Schaden'},
      {table: 'Auftrag', tableField: 'auAuftraggeberShort', repColumn: 'au_oeID_Auftraggeber'},
      {table: 'Auftrag', tableField: 'auAnsprechpartner'},
      {table: 'AuftragE_EIS', tableField: 'aueLetzterQSPruefer', groupCaption: 'Auftrag' , defaultValue: ''},
    ],
    uiSortFieldGroup: [
      {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgNr'},
      {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgFrist'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD'},
      {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenNr'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenDatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'Auftrag', fieldName: 'aueVersicherungsnehmer'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueAuftragsdatum'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtsterminPlan'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin2'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenmeldungVU'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueFristverlaengerungBis'},
      {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueZwischenberichtDatum'},
    ],
    uiFilter: [] as any[],
    uiSort: [] as any[],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    uiFilterAktiv(filterType?: number): any[] {
      return this.uiFilter
        .filter((filters: any) => !filterType || (filterType && filterType === filters.filterType))
        .filter((filters: any) =>
          ((filters.uiValue === true && filters.filterType === 1) ||
            (filters.filterCondition.value.length > 0 &&
              filters.filterType === 2))
        );
    },
    data: [] as any[],
    tableDefinition: [] as any[],
    distinctData: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 24} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
      dataDistinct: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 24,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    isLoading: true,
    ready: () => {
      if (!this.taskTable.data || this.taskTable.data.length === 0) {
        this.taskTable.state = 2;

        if (this.VCtaskTable) {
          this.VCtaskTable.selectedRow = -1;
        }
      } else {
        this.taskTable.state = 0;

        if (this.VCtaskTable) {
          this.VCtaskTable.selectedRow = 0;
        }
      }
      this.init = false;
      this.taskTable.isLoading = false;
      this.tableIsLoading.next(this.taskTable.isLoading);
      this.VCFilterChips?.workspace.computeMetaInfo(this.appSvc.helperObj.clone(this.taskTable.MetaInfo));
    },
    selectionChanged: (index: number) => {
      this.tableDrawerIsLoading.next(true);
      this.taskTable.selectedRow = this.taskTable.data[index];
      if (this.taskTable.selectedRow) {
        this.TaskSummary = this.dataSvc.Task.Summary.Get(
          this.taskTable.selectedRow.vorgID,
          undefined,
          {Events: this.Events}
        );
      }
    },
    pageChanged: (page: number) => {
      if (this.taskTable.MetaInfo.dataPaging !== undefined) {
        this.taskTable.MetaInfo.dataPaging.pageNo = page;
      }
      this.taskTable.loadData();
    },
    search: (value: string) => {
      this.taskTable.searchValue = value;
      this.taskTable.pageChanged(1);
    },
    loadData: () => {
      const SELF = this;
      SELF.taskTable.state = 1;
      SELF.taskTable.isLoading = true;
      SELF.tableIsLoading.next(SELF.taskTable.isLoading);
      SELF.excRest
        .sget(
          SELF.excRest.computeUrl('TaskR_List', {
            filter: this.taskTable.prefilter,
            fts: this.taskTable?.searchValue,
          }),
          'taskListState',
          {
            MetaInfo: {
              dataPaging: this.taskTable.MetaInfo.dataPaging,
              dataSort: this.taskTable.MetaInfo.dataSort,
              dataFilter: this.taskTable.MetaInfo.dataFilter
            }
          }
        )
        .subscribe((response: any) => {
          if (response.success && response.data) {
            SELF.taskTable.data = response.data.Vorgaenge;
            SELF.taskTable.paging = response.paging.Vorgaenge;
          } else {
            SELF.taskTable.data = [];
            SELF.taskTable.paging = {
              pagingPage: 0,
              pagingEndRow: 0,
              pagingPageSize: 25,
              pagingTotalPages: 0,
              pagingTotalRows: 0,
              pagingStartRow: 0,
            };
          }
          SELF.taskTable.ready();
        });
    },
    getDistinctData: (dataDistinct: IExcDataDistinct) => {
      this.taskTable.MetaInfo.dataDistinct = dataDistinct;
      this.excRest
        .sget(
          this.excRest.computeUrl('TaskR_List', {
            filter: this.taskTable.prefilter,
            fts: this.taskTable?.searchValue,
          }),
          ExcCoreModule.Guid.NewGuid(),
          {MetaInfo: this.taskTable.MetaInfo}
        ).subscribe((ret: any) => {
        console.log(ret.data);
        this.taskTable.distinctData = ret.data;
      });
    }
  };

  //#region TaskSummary
  TaskSummary: ITaskSummaryData | any = this.dataSvc.Task.Summary.Get();
  config = {
    leistungList: {
      selectKey: 'leID',
      state: 1,
      searchValue: '',
      selectedRow: undefined as any,
      isLoading: false
    },
    receiptList: {
      treeControl: new NestedTreeControl<any>(node => node.receipts),
      selectKey: 'rcptID',
      state: 1,
      searchValue: '',
      selectedRow: undefined as any,
      uiFilterEnumGroup: [
        {enmName: 'ReceiptStatus', enmField: 'rcpt_enmIdent_ReceiptStatus', enmTable: 'Receipt'},
        {enmName: 'ReceiptTyp', enmField: 'rcpt_enmIdent_ReceiptType', enmTable: 'Receipt'},
        {
          enmName: 'Schadenart', enmField: 'aue_enmIdent_SchadenArt', enmTable: 'AuftragE_EIS', enmAlt: false,
          enmAltTT: true
        },
        {enmName: 'VorgangStatus', enmField: 'vorg_enmIdent_VorgangStatus', enmTable: 'Vorgang'},
        {enmName: 'VorgangTyp', enmField: 'vorg_enmIdent_VorgangTyp', enmTable: 'Vorgang'},
        {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
      ],
      uiFilterSearchFields: [
        {tableField: 'vorgNr', table: 'Vorgang'},
        {tableField: 'Bearbeiter', table: 'Vorgang'},
        {tableField: 'Bearbeiter_Handy', table: 'Vorgang'},
        {tableField: 'vorgLCU', table: 'All', groupCaption: 'Vorgang'},
        {tableField: 'vorgLCD', table: 'All', groupCaption: 'Vorgang'},
        {groupCaption: 'Vorgang', table: 'All', tableField: 'vorgCKD'},
        {table: 'Vorgang', tableField: 'vorgFrist'},
        {tableField: 'aueSchadenNr', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
        {tableField: 'aueVersicherungsnehmer', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
        {tableField: 'aueSchadenOrt', table: 'AuftragE_EIS', groupCaption: 'Schaden'},
        {tableField: 'auAuftraggeberShort', table: 'Auftrag', repColumn: 'au_oeID_Auftraggeber'},
        {tableField: 'auAnsprechpartner', table: 'Auftrag'},
      ],
      uiSortFieldGroup: [
        {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgLCD'},
        {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCRD'},
        {fieldGroup: 'Vorgang', fieldTable: 'All', fieldName: 'vorgCKD'},
        {fieldGroup: 'Vorgang', fieldTable: 'Vorgang', fieldName: 'vorgFrist'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenDatum'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueAuftragsdatum'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtsterminPlan'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueOrtstermin2'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueSchadenmeldungVU'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueFristverlaengerungBis'},
        {fieldGroup: 'Auftrag', fieldTable: 'AuftragE_EIS', fieldName: 'aueZwischenberichtDatum'},
      ],
      uiFilter: [] as any [],
      uiSort: [] as any [],
      hasChild: (_: number, node: any): boolean => {
        return !!node.receipts && node.receipts.length > 0;
      },
      paging: {
        pagingPage: 0,
        pagingEndRow: 0,
        pagingPageSize: 25,
        pagingTotalPages: 0,
        pagingTotalRows: 0,
        pagingStartRow: 0
      },
      isLoading: true,
      ready: () => {
        if (this.TaskSummary.receiptList.data.length === 0) {
          this.config.receiptList.state = 2;
          // this.VCreceiptList.selectedRow = -1;
        } else {
          this.config.receiptList.state = 0;
          // this.VCreceiptList.selectedRow = 0;
        }
        this.config.receiptList.isLoading = false;
        this.tableDrawerIsLoading.next(true);
      },
      deleteReceipt: (event: any, rcptID: any, rcptUPT: any, rcptState: number) => {
        const SELF = this;

        event.preventDefault();
        event.stopPropagation();

        if (rcptState <= 2 || this.excSecurity.isFeatured('RECEIPTDELETE')) {
          SELF.modal.showSimple(
            this.getRessource('DeleteReceipt.Title'),
            this.getRessource('DeleteReceipt.Message'),
            true,
            true,
            this.getGlobal('Delete'),
            this.getGlobal('Cancel')
          ).subscribe((rtVal: boolean) => {
            if (rtVal) {
              SELF.config.receiptList.state = 1;
              SELF.config.receiptList.isLoading = true;
              SELF.excRest
                .delete(SELF.excRest.computeUrl('ReceiptD', {rcptID}), {rcptUPT}, {})
                .subscribe((ret: any) => {
                  if (ret) {
                    this.modal
                      .showToast(
                        ret.success
                          ? `${this.getGlobal('Success')} ${this.getGlobal('Delete')}`
                          : this.getGlobal('Cancel')
                        , `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`
                        , ret.success ? 'fal fa-trash-can-check' : 'fal fa-times-circle');
                    this.Events?.Receipt?.List?.Deleted?.emit({success: ret});
                  }
                });
            }
          });
        }
      }
    },
    flowTable: {
      state: 1,
      ready: () => {
        if (!this.TaskSummary?.flowTable.data || this.TaskSummary?.flowTable.data.length === 0) {
          this.config.flowTable.state = 2;
        } else {
          this.config.flowTable.state = 0;
        }
      },
    },
    attachmentJagTable: {
      state: 1,
      ready: () => {
        if (!this.TaskSummary?.attachmentJagTable.data || this.TaskSummary?.attachmentJagTable?.isEmpty) {
          this.config.attachmentJagTable.state = 2;
        } else {
          this.config.attachmentJagTable.state = 0;
        }
      },

      hasChild: (_: number, node: any): boolean => {
        return !!node.documents && node.documents.length > 0;
      },

      treeControl: new NestedTreeControl<any>(node => node.documents),
    },
    taskList: {
      selectedObjects: [] as any[],

      rowChange: (index: number) => {
        if (!this.config.taskList.selectedObjects.find((sOrt: any) => sOrt === this.TaskSummary?.taskList?.data[index])) {
          this.config.taskList.selectedObjects = [];
          this.config.taskList.selectedObjects.push(this.TaskSummary?.taskList?.data[index]);
        } else {
          this.VCVorganglist.selectedRow = -1;
          this.config.taskList.selectedObjects = [];
        }
      },
      itemSelect: (index: number) => {
        if (this.config.taskList.selectedObjects.find((sOrt: any) => sOrt === this.TaskSummary?.taskList?.data[index])) {
          this.config.taskList.selectedObjects =
            this.config.taskList.selectedObjects.filter((sOrt: any) => sOrt !== this.TaskSummary?.taskList?.data[index]);
        } else {
          this.config.taskList.selectedObjects.push(this.TaskSummary?.taskList?.data[index]);
        }
      },
    },
    formularVersionList: {
      selectedObjects: [] as any[],

      rowChange: (index: number) => {
        if (!this.config.formularVersionList.selectedObjects
          .find((sOrt: any) => sOrt === this.TaskSummary?.formularVersionList?.data[index])) {
          this.config.formularVersionList.selectedObjects = [];
          this.config.formularVersionList.selectedObjects.push(this.TaskSummary?.formularVersionList?.data[index]);
        } else {
          this.VCFormularList.selectedRow = -1;
          this.config.formularVersionList.selectedObjects = [];
        }
      },
      itemSelect: (index: number) => {
        if (this.config.formularVersionList.selectedObjects
          .find((sOrt: any) => sOrt === this.TaskSummary?.formularVersionList?.data[index])) {
          this.config.formularVersionList.selectedObjects =
            this.config.formularVersionList.selectedObjects
              .filter((sOrt: any) => sOrt !== this.TaskSummary?.formularVersionList?.data[index]);
        } else {
          this.config.formularVersionList.selectedObjects.push(this.TaskSummary?.formularVersionList?.data[index]);
        }
      },
    },
    photoDocumentation: {
      selectedObjects: [] as any[],
      isLoading: false,
    },

    getOEByID: (ID: string): any => {
      return ExcCoreModule.Array.GetObject(
        this.TaskSummary?.oeList?.data,
        'oeID',
        ID
      );
    },

    newMessage: (): void => {
      this.appSvc.Message.NewForTask.OpenTab(
        {objID: this.TaskSummary?.ID},
        {Events: this.Events}
      );
    },

    newDefaultMessage: (dmsgID: any): void => {
      this.appSvc.Message.NewForTask.OpenTab(
        {objID: this.TaskSummary?.ID, dmsgID: dmsgID},
        {Events: this.Events}
      );
    },

    newServiceRecord: (): void => {
      this.appSvc.Leistungserfassung.New(
        {fkID: this.TaskSummary?.ID, fkType: 'Vorgang'},
        {Events: this.Events}
      );
    },

    newReport: (): void => {
      this.appSvc.Report.New(this.TaskSummary?.ID, {Events: this.Events});
    },

    newNote: (): void => {
      this.appSvc.Note.OpenModal(
        {ntz_objID: this.TaskSummary?.ID},
        {Events: this.Events}
      );
    },

    showUploadReceiptModal: (): void => {
      this.appSvc.Receipt.Upload.OpenModal(
        {
          Data: {
            rcpt_vorgID: this.TaskSummary?.ID
            , rcptStatement: false
          },
          SummaryAttachmentTable: this.TaskSummary?.attachmentJagTable,
          ConfigAttachmentTable: this.config.attachmentJagTable
        },
        {Events: this.Events}
      );
    },

    showUploadStatementModal: (): void => {
      this.appSvc.Receipt.Upload.OpenModal(
        {
          Data: {
            rcpt_vorgID: this.TaskSummary?.ID
            , rcptStatementReason: this.TaskSummary?.taskDetails?.data?.vorgBeschreibung
            , rcptStatement: true
          },
          SummaryAttachmentTable: this.TaskSummary?.attachmentJagTable,
          ConfigAttachmentTable: this.config.attachmentJagTable
        },
        {Events: this.Events}
      );
    },

    showHistory: (): void => {
      this.appSvc.History.OpenModal(this.TaskSummary?.historyTable?.data);
    },
    showAttachmentUploadModal: (): void => {
      this.appSvc.Document.Upload.OpenModal(
        {dok_objID: this.TaskSummary?.ID},
        {Events: this.Events}
      );
    },

    showAttachmentPreview: (dokID?: string): void => {
      this.appSvc.Document.Preview.OpenModal(
        {objID: this.TaskSummary?.ID, attID: dokID},
        {Events: this.Events}
      );
    },

    openCheckViewCollection: (): void => {
      if (this.config.receiptList.selectedRow) {
        this.appSvc.Receipt.Checkview.OpenCollectionTab({
          rcptID:
            this.config.receiptList.selectedRow[
              this.config.receiptList.selectKey
              ],
        });
      }
    },

    onDblClickCheckView: (index: number): void => {
      if (this.config.receiptList.selectedRow) {
        this.appSvc.Receipt.Checkview.OpenTab(
          this.TaskSummary?.receiptList?.data[index].rcptID
        );
      }
    },

    openCheckView: (): void => {
      if (this.config.receiptList.selectedRow) {
        this.appSvc.Receipt.Checkview.OpenTab(
          this.config?.receiptList?.selectedRow?.rcptID
        );
      }
    },

    receiptCaseOpenTestReportPdf: (): void => {
      if (this.TaskSummary?.receiptList?.data?.length > 0
        && !this.config.receiptList.isLoading
      ) {
        this.config.receiptList.isLoading = true;
        this.appSvc.Receipt.Reporting.openCaseReport(
          this.TaskSummary?.caseDetails?.data?.auID,
          true,
          {Events: this.Events},
        );
      }
    },

    receiptTaskOpenTestReportPdf: (): void => {
      if (this.TaskSummary?.receiptList?.data?.length > 0
        && !this.config.receiptList.isLoading
      ) {
        this.config.receiptList.isLoading = true;
        this.appSvc.Receipt.Reporting.openTaskReport(
          this.TaskSummary?.ID,
          true,
          {Events: this.Events}
        );
      }
    },

    documentTemplateDownload: (dotID: string): void => {
      this.appSvc.DocumentTemplate.Download(this.TaskSummary?.ID, dotID);
      this.TaskSummary?.LoadSummary();
    },

    downloadPhotoDocumentation: (pdID: string): void => {
      this.config.photoDocumentation.isLoading = true;
      this.appSvc.PhotoDocumentation.Download(pdID, {Events: this.Events});
    }
  };
  //#endregion

  tableIsLoading = new BehaviorSubject(this.taskTable.isLoading);
  tableDrawerIsLoading = new BehaviorSubject(this.TaskSummary.isLoading);
  userType: any | number;

  constructor(
    private exgApplicationTabService: ExgApplicationTabService,
    public chDecRef: ChangeDetectorRef,
    public excRest: ExcRestService,
    private modal: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    private dataSvc: DataService,
    public excSecurity: ExcSecurityService,
    public app: AppComponent,
    private caseDataSvc: CaseDataService,
  ) {
    super();
    setInterval(() => {
      this.chDecRef.detectChanges();
    }, 15);
  }

  [key: string]: any;

  /* Lifecycle Hooks*/
  ngOnInit(): void {
    this.registerEvents();
    this.initialize();
    this.initTableDefinition();
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      if (this.exgApplicationTabService.StateTab?.Active) {
        this.taskTable.loadData();
      }
    });
    ExcCoreModule.Services().StrgI.subscribe(() => {
      if (this.exgApplicationTabService.StateTab?.Active) {
        this.rightDrawerVisible = !this.rightDrawerVisible;
      }
    });
    this.Events.Leistungserfassung?.New?.Save?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Message?.NewForTask?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Calculation?.Version?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.TaskSummary?.LoadSummary();
    });
    this.Events.NoteDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Receipt?.UploadDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Receipt?.List?.Deleted?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Document?.UploadDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Document?.UpdateDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Formular?.Version?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.tableDrawerIsLoading.next(true);
      this.TaskSummary?.LoadSummary();
    });
    this.Events.Task?.Summary?.DataLoaded?.subscribe((evt: ExgEventArgs) => {
      if (evt.success) {
        this.config.receiptList.ready();
        this.config.flowTable.ready();
        this.config.attachmentJagTable.ready();
      }
      this.tableDrawerIsLoading.next(false);
    });
    this.Events.Receipt?.Preview?.Downloaded?.subscribe((evt: ExgEventArgs) => {
      this.config.receiptList.isLoading = false;
    });
    this.enumSvc.repositoryLoaded.subscribe(() => {
      this.initEnumerations();
      this.initTableDefinition();
    });
    this.tableDrawerIsLoading.subscribe(async (value) => {
      await this.chDecRef.reattach();
      if (!value) {
        await new Promise(f => setTimeout(f, 1000));
        this.chDecRef.detach();
      }
    });
    this.tableIsLoading.subscribe(async (value) => {
      await this.chDecRef.reattach();
      if (!value) {
        await new Promise(f => setTimeout(f, 1000));
        this.chDecRef.detach();
      }
    });
    this.VCtableDefinitionSettings?.resetted.subscribe((evt: any) => {
      this.initTableDefinition();
    });
    this.Events.Questionnaire?.CreateUpdateVersion?.Closed?.subscribe((ret: any) => {
      if (ret?.success) {
        this.TaskSummary?.LoadSummary();
      }
    });
    this.Events.PhotoDocumentation?.Download?.Finished?.subscribe( (ret: any) => {
      if (ret?.success) {
        this.config.photoDocumentation.isLoading = false;
        this.modal.showToast('Download erfolgreich', 'md-toast', 'fas fa-check');
      }
      else {
        this.config.photoDocumentation.isLoading = false;
        this.modal.showToast('Download fehlgeschlagen', 'md-toast', 'fas fa-exclamation');
      }
    });
  }

  initialize(): void {
    const SELF = this;
    if (SELF.tabinstance) {
      SELF.tabinstance.Label = SELF.getRessource('Label');
    }
    SELF.userType = Number(SELF.appSvc.UserAttributes()?.type) || 2;

    SELF.initEnumerations();
    SELF.rightTabs = [
      {
        get caption(): string {
          return SELF.getResource('Tabs.Details.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Details.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Attachments.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Attachments.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('DOCUMENTREAD');
        }
      },
      {
        get caption(): string {
          return 'Bericht';
        },
        get icon_class(): string {
          return 'fal fa-clipboard-list';
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('RQUESTVREAD')
            && !SELF.excSecurity.isFeatured('RPHOTOREAD')
            && !SELF.excSecurity.isFeatured('RCALCVREAD');
        }
      },
      {
        get caption(): string {
          return 'Formulare';
        },
        get icon_class(): string {
          return 'fal fa-pen-field';
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('FORMVREAD');
        },
        get hidden(): boolean {
          return !SELF.excSecurity.isFeatured('FORMVREAD');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Receipts.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Receipts.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('RECEIPTREAD');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.ServiceRecords.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.ServiceRecords.Icon');
        },
        get disabled(): boolean {
          return !SELF.excSecurity.isFeatured('DEVELOPMENT'); // war LERFNAV
        },
        get hidden(): boolean {
          return !SELF.excSecurity.isFeatured('DEVELOPMENT'); // war LERFNAV
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.DialogueQuestions.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.DialogueQuestions.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Progress.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Progress.Icon');
        }
      },
      {
        get caption(): string {
          return SELF.getResource('Tabs.Task.HeaderText');
        },
        get icon_class(): string {
          return SELF.getResource('Tabs.Task.Icon');
        }
      },
    ];

    SELF.preFilterDefinition = [
      {
        value: 'active',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [],
      },
      {
        value: 'closed',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '81',
            get caption(): string {
              return SELF.getRessource('closed.' + this.value);
            },
          },
          {
            value: '82',
            get caption(): string {
              return SELF.getRessource('closed.' + this.value);
            },
          },
          {
            value: '83',
            get caption(): string {
              return SELF.getRessource('closed.' + this.value);
            },
          }
        ],
      },
      {
        value: 'cancelled',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '91',
            get caption(): string {
              return SELF.getRessource('cancelled.' + this.value);
            },
          },
          {
            value: '92',
            get caption(): string {
              return SELF.getRessource('cancelled.' + this.value);
            },
          },
          {
            value: '93',
            get caption(): string {
              return SELF.getRessource('cancelled.' + this.value);
            },
          }
        ],
      },
      {
        value: 'all',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [],
      },
    ];

    if (SELF.userType === 1) {
      SELF.preFilterDefinition[0].types.push({
        value: '1',
        get caption(): string {
          return SELF.enumSvc.getEnumerationText('VorgangStatus', Number(this.value));
        },
      });
    }
    SELF.preFilterDefinition[0].types.push(
      {
        value: '2',
        get caption(): string {
          return SELF.enumSvc.getEnumerationText('VorgangStatus', Number(this.value));
        },
      },
      {
        value: '3',
        get caption(): string {
          return SELF.enumSvc.getEnumerationText('VorgangStatus', Number(this.value));
        },
      },
      {
        value: '4',
        get caption(): string {
          return SELF.enumSvc.getEnumerationText('VorgangStatus', Number(this.value));
        },
      },
      {
        value: '5',
        get caption(): string {
          return SELF.enumSvc.getEnumerationText('VorgangStatus', Number(this.value));
        },
      },
      {
        value: '13',
        get caption(): string {
          // return SELF.getRessource('active.' + this.value);
          return SELF.enumSvc.getEnumerationText('VorgangStatus', Number(this.value));
        }
      },
      {
        value: '14',
        get caption(): string {
          // return SELF.getRessource('active.' + this.value);
          return SELF.enumSvc.getEnumerationText('VorgangStatus', Number(this.value));
        }
      },
      {
        value: '7', get caption(): string {
          return SELF.enumSvc.getEnumerationText('VorgangStatus', Number(this.value));
        }
      },
      {
        value: '6',
        get caption(): string {
          return SELF.enumSvc.getEnumerationText('VorgangStatus', Number(this.value));
        },
      },
      {
        value: '11',
        get caption(): string {
          return SELF.enumSvc.getEnumerationText('VorgangStatus', Number(this.value));
        },
      },
      {
        value: '999',
        get caption(): string {
          return SELF.getRessource(`active.${Number(this.value)}`);
        },
      },
      {
        value: '0',
        get caption(): string {
          return SELF.getRessource('active.' + this.value);
        },
      }
    );

    for (let i = new Date().getFullYear(); i >= new Date().getFullYear() - 3; i--) {
      SELF.preFilterDefinition[1].types.push(
        {
          value: '-8' + i,
          get caption(): string {
            return i as unknown as string;
          },
        }
      );
      SELF.preFilterDefinition[2].types.push(
        {
          value: '-9' + i,
          get caption(): string {
            return i as unknown as string;
          },
        }
      );
      SELF.preFilterDefinition[3].types.push(
        {
          value: '-1' + i,
          get caption(): string {
            return i as unknown as string;
          },
        }
      );
    }
    SELF.preFilterDefinition[1].types.push(
      {
        value: '8',
        get caption(): string {
          return SELF.getRessource('closed.' + this.value);
        },
      }
    );
    SELF.preFilterDefinition[2].types.push(
      {
        value: '9',
        get caption(): string {
          return SELF.getRessource('cancelled.' + this.value);
        },
      }
    );

    SELF.preFilterDefinition[3].types.push(
      {
        value: '-1',
        get caption(): string {
          return SELF.getRessource('all.' + this.value);
        },
      }
    );
    if (SELF.Data?.inputPreFilterValue) {
      SELF.taskTable.prefilter = SELF.Data.inputPreFilterValue;
      if (!(SELF.Data?.inputPreFilterValue >= 0)) {
        SELF.selectedMod = SELF.preFilterDefinition[1];
        SELF.taskTable.prefilter = 8;
      }
    }
  }

  initTableDefinition(): void {
    this.taskTable.tableDefinition = [
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorgNr')
        , value: 'vorgNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')
        , value: 'aueSchadenNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'aueVersicherungsnehmer')
        , value: 'aueVersicherungsnehmer'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenOrt')
        , value: 'aueSchadenOrt'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'au_oeID_Auftraggeber')
        , value: 'auAuftraggeberShort'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_SchadenArt')
        , value: 'aue_enmIdent_SchadenArt'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('Schadenart', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')
        , value: 'aue_enmIdent_Versicherungsart'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('Versicherungsart', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorg_enmIdent_VorgangTyp')
        , value: 'vorg_enmIdent_VorgangTyp'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('VorgangTyp', value);
        }
      },
      {
        caption: this.getRessource('TableRenames.Bearbeiter')
        , value: 'vorgBearbeiter'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.lastSV')
        , value: 'aueLetzterSachverstaendiger'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.lastSP')
        , value: 'aueLetzterSanierungspartner'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueLetzterQSPruefer')
        , value: 'aueLetzterQSPruefer'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.OrtsterminIst')
        , value: 'aueOrtstermin'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.aueOrtstermin2')
        , value: 'aueOrtstermin2'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.OrtsterminPlan')
        , value: 'aueOrtsterminPlan'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date'
        , dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueKontaktaufnahmeVersuche')
        , value: 'contactAttempt'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CKU')
        , value: 'vorgCKU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CKD')
        , value: 'vorgCKD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCU')
        , value: 'vorgLCU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCD')
        , value: 'vorgLCD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorgFristDiff')
        , value: 'vorgFristDifference'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorgFrist')
        , value: 'vorgFrist'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.getRessource('TableRenames.AbrechnungsHinweis')
        , value: 'aueAbrechnungshinweis_enmIdent'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return value ? this.enumSvc.getEnumerationText('Abrechnungshinweis', value) : '';
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Vorgang', 'vorg_enmIdent_VorgangStatus')
        , value: 'vorg_enmIdent_VorgangStatus'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('VorgangStatus', value);
        }
      },
    ];
  }

  ngAfterViewInit(): void {
    if (!this.selectedMod) {
      this.selectedMod = this.preFilterDefinition[0];
    }
    this.selectedType = this.selectedMod.types.find((i: any) => {
      return i.value === String(this.taskTable.prefilter);
    });

    if (this.Data?.addValue) {
      if (this.Data.addValue.vorgangstatusFilter)
      {
        this.taskTable.uiFilter.forEach(filter => {
          if (filter.filterField === 'vorg_enmIdent_VorgangStatus') {
            if (Array.isArray(this.Data.addValue.vorgangstatusFilter)) {
              if (this.Data.addValue.vorgangstatusFilter.includes(filter.filterIdent)) {
              filter.uiValue = true;
              }
            } else if (filter.filterIdent === this.Data.addValue.vorgangstatusFilter) {
              filter.uiValue = true;
            }
          }
        });
      }
      this.taskTable.uiFilter.forEach(filter => {
        if (filter.filterType === 2 && filter.filterCondition?.value && filter.filterCondition.value.length > 0){
          filter.uiValue = true;
        }
      });
    }
    this.VCtaskTableFilterControl.ApplyFilter();
    this.VCtaskTableSearchControl.ApplyFilter();
    setTimeout(() => {
      this.updateFilterChips();
    }, 1500);
  }
  updateFilterChips(): void {
    if (this.VCFilterChips && this.taskTable.MetaInfo) {
      this.VCFilterChips.workspace.computeMetaInfo(this.appSvc.helperObj.clone(this.taskTable.MetaInfo));
      this.chDecRef.detectChanges();
    }
  }

  initEnumerations(): void {
    if (this.Data?.addValue) {
      for (const uiFilterSearchField of this.taskTable.uiFilterSearchFields) {
        if (uiFilterSearchField.tableField === 'aueLetzterQSPruefer') {
          uiFilterSearchField.defaultValue = this.app?.userData?.OEFullname || this.excSecurity?.UserName;
        }
      }
    }
    this.taskTable.uiFilter = this.appSvc.metaInfo.dataFilter(
      this.taskTable.uiFilterEnumGroup,
      this.taskTable.uiFilterSearchFields);
    this.taskTable.uiSort = this.appSvc.metaInfo.dataSort(this.taskTable.uiSortFieldGroup);
    this.config.receiptList.uiFilter = this.appSvc.metaInfo.dataFilter(
      this.config.receiptList.uiFilterEnumGroup,
      this.config.receiptList.uiFilterSearchFields);
    this.config.receiptList.uiSort = this.appSvc.metaInfo.dataSort(this.config.receiptList.uiSortFieldGroup);
  }

  //#region TaskList
  changePreFilterMod(event: any): void {
    this.selectedMod = event;
    // this.messageTable.prefilterMod = event.value;
    this.changePreFilterType(this.selectedMod.types[0]);
  }

  changePreFilterType(event: any): void {
    this.selectedType = event;
    this.taskTable.prefilter = event.value;
    this.VCtaskTableFilterControl.ApplyFilter();
  }


  rightTabs_tabChange($event: number): void {
    switch ($event) {
      case 4:
        this.config.receiptList.ready();
        break;
      default:
        break;
    }
    this.chDecRefWakeUp();
  }

  toggleRightDrawer(): void {
    this.chDecRef.reattach();
    this.rightDrawerVisible = !this.rightDrawerVisible;

    if (this.rightDrawerVisible && this.taskTable.selectedRow) {
      this.TaskSummary = this.dataSvc.Task.Summary.Get(
        this.taskTable.selectedRow.vorgID,
        undefined,
        {Events: this.Events}
      );
    }
  }


  //#endregion TaskList
  async openWorkspaceV2(index?: number): Promise<void> {
    let taskRow = this.taskTable.selectedRow[this.taskTable.selectKey];
    if (index) {
      taskRow = this.taskTable.data[index][this.taskTable.selectKey];
      // For DblClick
      await new Promise(f => setTimeout(f, 150));
    }
    if (taskRow) {
      this.appSvc.Task.Workspace.OpenTabV2(taskRow, {Events: this.Events});
    }
  }

  async openCase(): Promise<void> {
    if (!this.excSecurity.isFeatured('CASEREAD')) {
      return;
    }
    const caserow = this.taskTable.selectedRow;
    if (caserow) {
      this.appSvc.Case.Workspace.OpenTabV2(this.TaskSummary.taskDetails.data.vorg_auID, {Events: this.Events});
    }
  }

  chDecRefWakeUp(): void {
    this.tableDrawerIsLoading.next(false);
  }

  OpenDetailHistoryModal(): void {
    if (!this.taskTable.isLoading
      && this.taskTable.selectedRow[this.taskTable.selectKey]) {
      this.modal
        .show('ModalDetailHistoryComponent', {
          ID: this.taskTable.selectedRow[this.taskTable.selectKey],
          Object: this.TaskSummary.taskDetails.data
        })
        .subscribe(() => {
        });
    }
  }

  openTableSettings($event: any): void {
    if (this.taskTable.newV2Table) {
      this.VCtableDefinitionSettings.openFilterConfig($event);
    }
  }

  openFileOverview(): void {
    this.appSvc.Document.Manager.OpenOverlay({vorgID: this.taskTable.selectedRow[this.taskTable.selectKey], Events: this.Events});
  }

  onClickOpenTaskCheckview(task: any): void {
    if (this.excSecurity.isFeatured('TASKREAD')) {
      this.appSvc.Task.Workspace.OpenTabV2(task.vorgID, {Events: this.Events});
    }
  }

  createNewQuestionnaireVersion(id: any): void {
    const data = {vorgID: this.taskTable.selectedRow[this.taskTable.selectKey], qcnfID: id};
    this.appSvc.QuestionnaireVersion.OpenModal(data, {Events: this.Events});
  }

  createNewFormularVersion(row: any): void {
    if (this.excSecurity.isFeatured('FORMVCREATE')) {
      const data = {fkID: this.taskTable.selectedRow[this.taskTable.selectKey], frmTID: row.frmTID, frmTName: row.frmTName};
      this.appSvc.Formular.Version.OpenTab(data, {Events: this.Events});
    }
  }

  createNewCalculationVersion(row: any): void {
    const sameType: any[] = this.TaskSummary?.calculationVersion?.data.filter((line: any) => {
      return line.cv_ctID === row.ctID;
    });
    if (sameType.length === 0)
    {
      this.createNewCalculationFromTemplate(row);
      return;
    }
    else {
      const lastOfType: any = sameType.reduce((max: any, current: any) => {
        return current.cvLCD > max.cvLCD ? current : max;
      } );
      if ([10, 20].includes(lastOfType.cvCalculationVersionStatus_enmIdent)) {
        this.modal.showSimple( 'Neue Kalkulation aus Datenquelle'
          , 'Es wurde im Auftrag bereits eine Kalkulation mit diesem Typ gefunden, die bereits abgeschlossen ist. ' +
          'Möchten Sie eine neue Kalkulation mit den übernommenen Werten anlegen?'
          , true, true, 'Ja, anlegen', 'Abbrechen')
          .subscribe((response: any) => {
            if (response) {
              this.createNewCalculationWithPreset(lastOfType, row);
            }
          });
      }
      else {
        this.modal.showSimple( 'Kalkulation bereits vorhanden'
          , 'Es wurde im Auftrag bereits eine Kalkulation mit diesem Typ gefunden, die noch offen ist. ' +
          'Möchten Sie die vorhandene Kalkulation öffnen?'
          , true, true, 'Ja, öffnen', 'Abbrechen')
          .subscribe((response: any) => {
            if (response) {
              this.openExistingCalculationVersion(lastOfType);
            }
          });
      }
    }
  }

  openExistingCalculationVersion(row: any): void  {
    const data = {
      cv_ctID: row.ctID,
      cv_fkID: row.cv_FKID,
      sourceID: this.TaskSummary?.taskDetails?.data?.vorgID
    };

    if (row.cvID) {
      Object.assign(data, {cvID: row.cvID});
    }

    const tab = new ExgApplicationTab(
      row.cvName ?? row.ctName,
      CalculationVersionComponent,
      data,
      row.cvID
      , {
        Close: () => {
          this.Events?.Calculation?.Version?.Closed?.emit();
        }
      }
    );
    tab.Open();
  }

  createNewCalculationWithPreset(presetCalculation: any, template: any): void {
    const data = {
      cvID: presetCalculation.cvID,
      cv_ctID: template.ctID,
      cv_fkID: this.taskTable.selectedRow[this.taskTable.selectKey],
      sourceID: this.TaskSummary?.taskDetails?.data?.vorgID,
      cvData: presetCalculation.cvData,
      cvName: 'Vorlage von ' + presetCalculation.cvName,
      cvDescription: presetCalculation.cvDescription,
      isNewFromPreset: true
    };
    const tab = new ExgApplicationTab(
      data.cvName,
      CalculationVersionComponent,
      data,
      data.cvID
      , {
        Close: () => {
          this.Events?.Calculation?.Version?.Closed?.emit();
        }
      }
    );
    tab.Open();
  }

  createNewCalculationFromTemplate(row: any): void {
    const data = {
      cv_ctID: row.ctID,
      cv_fkID: this.taskTable.selectedRow[this.taskTable.selectKey],
      sourceID: this.TaskSummary?.taskDetails?.data?.vorgID,
      cvName: row.ctName,
      isNew: true
    };

    // if (row.cvID) {
    //   Object.assign(data, {cvID: row.cvID});
    // }
    const tab = new ExgApplicationTab(
      row.cvName ?? row.ctName,
      CalculationVersionComponent,
      data,
      data.cv_ctID
      , {
        Close: () => {
          this.Events?.Calculation?.Version?.Closed?.emit();
        }
      }
    );
    tab.Open();
  }

  saveReportFolderStates(sources: string[]): void {
    this.openReportFolder = sources;
  }

  saveAttachmentFolderStates(sources: string[]): void {
    this.openAttachmentFolder = sources;
  }

  addVNData(): void {
    this.appSvc.VnData.AddData(this.TaskSummary, { Events: this.Events });
  }

  openReportBuilderOverlay(): void {
    if (!this.taskTable.isLoading || this.taskTable.selectedRow) {
      this.appSvc.ReportBuilder.DocBuilder.OpenTab(
        {vorgID: this.TaskSummary?.taskDetails?.data?.vorgID, Events: this.Events});
    }
  }
}
